<template>
    <div :class="stepWrapperClasses" :key="step">
        <h5 class="step-field-heading"><span class="las back" v-if="showPrev" @click="back()">
        <img src="../../assets/arrow_back-24px.svg" >
        </span><span class="step-field-heading-text">Select Service</span></h5>
        <div v-if="servicesLoaded" class="step-fields-body step-fields-list-box service-wrapper">
            <service-row
            v-for="item in stepData.service"
            :key="item.id"
            :value="value"
            :item="item"
            :allowSelect="true"
            v-on:filled-out="addServiceBookingDetails($event)"></service-row>
        </div>
        <div v-else-if="servicesEmpty" class="alert alert-primary">
            Sorry! No services available at this location.
        </div>
        <div v-else class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
    </div>
</template>

<script>
  import { mapMutations, mapState, mapGetters } from 'vuex';
  import axios from 'axios';
  import ServiceRow from './ServiceRow';
  import schedulingMixin from '../../mixins/schedulingMixin';

  export default {
    mixins: [schedulingMixin],
    data() {
        return {
            cancelToken: ''
        }
    },
    props: {
      field: {},
      details: {},
      value: '',
      index: '',
    },
    methods: {
        ...mapMutations('scheduling', [
          'addBookingDetails',
          'nextStep',
          'prevStep',
          'setStepData'// referenced in the mixin
        ]),
        async loadServices(token) {
            var response;
            var params = {
                params: this.getParams(),
                cancelToken: token
            };
            response = await axios.get(`${this.domain}/forms/api/v1/forms/${this.formId}/integrations/scheduling/api/services`, params);
            this.setCurrentStepData(response.data);
        },
        back() {
            this.prevStep();
            this.cancelToken.cancel();
        },
        getParams() {
            return {
                'location' : this.bookingDetails.location.id
            }
        },
        addServiceBookingDetails(value) {
            let service = this.getServiceById(value);
            let oldService = this.bookingDetails.service;
            this.addBookingDetails({
                'type' : 'service',
                'details' : service
            });
            this.nextStep();
            if (!oldService || oldService.id != service.id) {
                this.resetStepData();
            }
            this.$emit('filled-out',service);
        },
        getServiceById(id) {
            let services = this.stepData.service.filter(service => service.id == id);
            if (services[0]) {
                return services[0];
            } else {
                return {};
            }
        }
    },
    created() {
        if (!this.servicesLoaded) {
            this.cancelToken = axios.CancelToken.source();
            this.loadServices(this.cancelToken.token);
        }
    },
    computed: {
        ...mapGetters('form', [
          'fields',
          'domain'
        ]),
        ...mapState('form', { form: 'form', formId: 'formId' }),
        ...mapState('scheduling', { step: 'step', stepData: 'stepData', bookingDetails: 'bookingDetails' }),
        servicesLoaded() {
            return this.stepData.service !== '' && !this.servicesEmpty;
        },
        servicesEmpty() {
            return Array.isArray(this.stepData.service) && this.stepData.service.length == 0;
        },
        showPrev() {
            return this.isNotFirstStep
                && (!this.form.hasOwnProperty('location')
                || this.form.location === ''
                || this.form.location === null);
        }
    },
    components: {
        ServiceRow,
    },
  };
</script>
